export const FUND_VALUE_RANGE_SENSITIVITY_HEADER = 'Fund Value Range Sensitivity';
export const SHARE_VALUE_RANGE_SENSITIVITY_HEADER = 'Share Value Range Sensitivity';
export const COMPANY_VALUE_RANGE_SENSITIVITY_HEADER = 'Company Value Range Sensitivity';
export const RANGE_SENSITIVITY_LABEL = 'Range Sensitivity';
/** Base logical name; each instance uses a unique workbook key from {@link getRangeSensitivityWorkbookKey}. */
export const RANGE_SENSITIVITY_SPREADSHEET_NAME = 'rangeSensitivity';

/** Unique `SpreadsheetConfig.name` / workbook entry per range-sensitivity panel. */
export function getRangeSensitivityWorkbookKey(panelId: string): string {
  const slug = String(panelId ?? '').replaceAll('-', '_');
  return `${RANGE_SENSITIVITY_SPREADSHEET_NAME}-${slug}`;
}

/**
 * Workbook key for the companion sensitivity-percentage input sheet.
 * Uses underscores only so it is safe as a cross-sheet expression identifier.
 */
export function getRangeSensitivityPctWorkbookKey(panelId: string): string {
  const slug = String(panelId ?? '').replaceAll('-', '_');
  return `rangeSensitivityPct_${slug}`;
}

// Column headers
export const COLUMN_HEADER_SENSITIVITY_RANGE = 'Sensitivity Range';
export const COLUMN_HEADER_LOWER_BOUND = 'Lower Bound';
export const COLUMN_HEADER_CONCLUDED_VALUE = 'Mid Point';
export const COLUMN_HEADER_UPPER_BOUND = 'Upper Bound';

/** Unicode PLUS-MINUS SIGN (same visual as HTML `&plusmn;`) — prepended to Sensitivity Range values. */
export const RANGE_SENSITIVITY_PLUS_MINUS_PREFIX = '\u00B1';

export const RANGE_SENSITIVITY_COLUMN_HEADERS = [
  COLUMN_HEADER_LOWER_BOUND,
  COLUMN_HEADER_CONCLUDED_VALUE,
  COLUMN_HEADER_UPPER_BOUND,
];

// Formats
export const RANGE_SENSITIVITY_STATIC_CUSTOM_FORMAT = Object.freeze({
  currency: {
    units: '',
  },
});
